import React, { Fragment } from 'react';
import Alert from 'react-bootstrap/Alert';
import Draggable from 'react-draggable';

// Embed React component or string into alert
const AlertContents = ({ contents }) => {
  if (typeof contents === 'function') {
    const Contents = contents;
    return <Contents />;
  }
  else {
    return <p>{contents}</p>;
  }
};

const CustomAlert = ({ alert, onClose }) => {
  if (!alert.showing) {
    return null;
  }

  const variant = alert.variant || 'secondary';                                 
  const Wrapper = alert.draggable ? Draggable : Fragment;
  if (alert.timeOut) {
    setTimeout(onClose, alert.timeOut);
  }

  return (
    <Wrapper>
      <Alert
        variant={variant}
        onClose={onClose}
        dismissible
        className={alert.className || 'fixed-alert'}
      >
        {alert.header && <Alert.Heading>{alert.header}</Alert.Heading>}
        <AlertContents contents={alert.contents} />
      </Alert>
    </Wrapper>
  );
};

export default CustomAlert;